/**
 * CTA variants — now language-aware. Each variant key maps to translation paths.
 * Use with: const cta = useCtaVariant();  // returns the current translated variant object
 */
import { useLanguage } from "@/lib/i18n";

export const VARIANT_KEYS = ["info", "plan", "reserva", "whatsapp"];

export function getVariantKeyFromUrl() {
  if (typeof window === "undefined") return "info";
  const params = new URLSearchParams(window.location.search);
  const v = (params.get("variant") || "").toLowerCase();
  return VARIANT_KEYS.includes(v) ? v : "info";
}

/**
 * Hook: returns the translated CTA variant object for the current language.
 */
export function useCtaVariant() {
  const { t } = useLanguage();
  const key = getVariantKeyFromUrl();
  return {
    key,
    eyebrowFinal: t(`ctaVariants.${key}.eyebrowFinal`),
    heroButton: t(`ctaVariants.${key}.heroButton`),
    navButton: t(`ctaVariants.${key}.navButton`),
    finalButton: t(`ctaVariants.${key}.finalButton`),
    finalH2Pre: t(`ctaVariants.${key}.finalH2Pre`),
    finalH2Mid: t(`ctaVariants.${key}.finalH2Mid`),
    finalH2Post: t(`ctaVariants.${key}.finalH2Post`),
    finalDescription: t(`ctaVariants.${key}.finalDescription`),
    successTitle: t(`ctaVariants.${key}.successTitle`),
    successBody: t(`ctaVariants.${key}.successBody`),
  };
}

/**
 * Build a wa.me URL with prefilled message (optional email context).
 */
export function buildWhatsAppLink(email) {
  const rawNumber = process.env.REACT_APP_WHATSAPP_NUMBER || "";
  if (!rawNumber) return null;
  const digits = rawNumber.replace(/\D/g, "");
  if (!digits) return null;
  const baseMsg =
    process.env.REACT_APP_WHATSAPP_MESSAGE ||
    "Hola! Vinc del landing d'AI METABOLIC i m'agradaria saber-ne més.";
  const fullMsg = email ? `${baseMsg} (Email: ${email})` : baseMsg;
  return `https://wa.me/${digits}?text=${encodeURIComponent(fullMsg)}`;
}
